export enum PaymentSteps {
  OVEWVIEW = 'overview',
  SUGGESTION = 'loginSuggestion',
  CREDENTIALS = 'credentials',
  RESULT = 'result',
}

export type ResultType = 'success' | 'fail' | 'unknown'

export type ResultParams = {
  orderNr?: number
}
